import { IdrReviewMessageContentSchema } from "@hightouch/lib/idr/change-plans/graph-review-schema";
import { z } from "zod/v4";
import type { SchemaMessageDefinition } from "../../schema";

export const IdrChangePlanMessageContentSchema = IdrReviewMessageContentSchema;

export const IdrChangePlanResponseSchema = z.object({
  type: z.literal("idr_change_plan"),
  content: IdrChangePlanMessageContentSchema,
});

export type IdrChangePlanMessage = z.infer<typeof IdrChangePlanResponseSchema>;

export const IdrChangePlanMessageDefinition: SchemaMessageDefinition<
  typeof IdrChangePlanResponseSchema
> = {
  type: "idr_change_plan",
  schema: IdrChangePlanResponseSchema,
};
